import { styled, theme } from '@/src/stitches.config'

export const GradientText = styled('span', {
    background: `-webkit-linear-gradient(83.53deg, ${theme.colors.primary} 18.47%, ${theme.colors.secondary} 78%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
})
